module.exports = " <div class=reservations-table-row-head> <div class=-row> <div class=-cell v-bind:style=cellStyle><slot></slot></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/reservations/reservations-table/row/head.vue
// module id = 237
// module chunks = 0